import React, { useCallback, useEffect, useReducer, useImperativeHandle, forwardRef } from 'react'
import { message as $message, Pagination, Space } from 'antd'

import styles from './index.less'

import Image from '@/components/TableWidgets/Image'
import { AntdBaseTable, transformSelectedRowKeysToSelectedRows } from '@/components/AntdBaseTable'

import { initialState, reducer } from './reducer'

export default forwardRef(
    (
        { rowKey = 'id', fetch, query, selected, setSelected, selectedRows, setSelectedRows, modalType, ...restProps },
        ref
    ) => {
        const [state, dispatchState] = useReducer(reducer, initialState)

        const load = useCallback(
            async params => {
                dispatchState({
                    type: 'UPDATE',
                    payload: {
                        loading: true
                    }
                })

                const response = await fetch({
                    ...(params || {})
                })

                dispatchState({
                    type: 'UPDATE',
                    payload: {
                        loading: false
                    }
                })

                if (response) {
                    const { success, message, data, total } = response
                    if (success) {
                        dispatchState({
                            type: 'UPDATE',
                            payload: {
                                data: data || [],
                                total: total || 0
                            }
                        })
                        return response
                    } else {
                        $message.error(message)
                    }
                }

                throw new Error()
            },
            [fetch]
        )

        const refresh = useCallback(() => {
            const { pageNum, pageSize } = state

            try {
                load({
                    pageNum,
                    pageSize
                })
            } catch (e) {
                console.error('catchError', e)
            }
        }, [load, state])

        const reload = useCallback(async () => {
            const { pageSize } = state

            const params = {
                pageSize,
                pageNum: 1
            }

            try {
                const { success } = await load(params)

                if (success) {
                    dispatchState({
                        type: 'UPDATE',
                        payload: params
                    })
                }
            } catch (e) {
                console.error('catchError', e)
            }
        }, [load, state.pageSize])

        useEffect(() => {
            reload()
        }, [reload])

        useImperativeHandle(
            ref,
            () => ({
                refresh,
                reload
            }),
            [refresh, reload]
        )

        const rowSelection = {
            columnWidth: 40,
            onChange: keys => {
                setSelected(keys)
                setSelectedRows(transformSelectedRowKeysToSelectedRows(keys, state.data, rowKey))
            },
            value: selected,
            preserveSelectedRowKeys: true
        }

        const goodsColumns = [
            {
                title: '图片',
                code: 'pic',
                width: 52,
                align: 'center',
                render(_) {
                    const data = _ ? [_] : ['https://assets.sursung.com/pkg/static/ops/19052010009498_2.jpg']
                    return <Image size={40} dataSource={data} />
                }
            },
            {
                title: '资料编码',
                code: 'styleCode',
                width: 150,
                align: 'left'
            },
            {
                title: '商品编码',
                code: 'itemCode',
                width: 180,
                align: 'left'
            },
            {
                title: '商品名称',
                code: 'itemName',
                width: 190,
                align: 'left'
            },
            {
                title: '商品简称',
                code: 'itemShortName',
                width: 120,
                align: 'left'
            },
            {
                title: '颜色规格',
                code: 'propertiesValue',
                width: 180,
                align: 'left'
            },
            {
                title: '基本售价',
                code: 'price',
                align: 'center',
                width: '90px'
            }
        ]
        const styleColumns = [
            {
                title: '图片',
                code: 'pic',
                width: 52,
                align: 'center',
                render(_) {
                    const data = _ ? [_] : ['https://assets.sursung.com/pkg/static/ops/19052010009498_2.jpg']
                    return <Image size={40} dataSource={data} />
                }
            },
            {
                title: '资料编码',
                code: 'styleCode',
                width: 200,
                align: 'left'
            },
            {
                title: '商品名称',
                code: 'itemName',
                width: 190,
                align: 'left'
            },
            {
                title: '基本售价',
                code: 'supplyPrice',
                align: 'center',
                width: '90px'
            }
        ]

        return (
            <>
                <div className={styles.container}>
                    <AntdBaseTable
                        style={{ maxHeight: '376px', overflowY: 'auto' }}
                        primaryKey={rowKey}
                        isLoading={state.loading}
                        useOuterBorder={true}
                        columns={modalType === 'goods' ? goodsColumns : styleColumns}
                        dataSource={state.data}
                        rowSelection={rowSelection}
                        {...restProps}
                    />
                </div>

                <div className={styles.pagination}>
                    <Pagination
                        showQuickJumper={true}
                        current={state.pageNum}
                        pageSize={state.pageSize}
                        total={state.total}
                        size="small"
                        onChange={(page, pageSize) => {
                            dispatchState({
                                type: 'UPDATE',
                                payload: {
                                    pageNum: page,
                                    pageSize
                                }
                            })
                            if (pageSize === state.pageSize) {
                                load({
                                    pageNum: page,
                                    pageSize
                                })
                            }
                        }}
                    />
                </div>
            </>
        )
    }
)
